import Card from "components/card";
import React, { useState, useEffect } from "react";
import api from "services/api";

const EditProfile = ({ session, onUpdate }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (session) {
      setForm({
        name: session.name || "",
        email: session.email || "",
        password: "",
      });
    }
  }, [session]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage("");
    setError("");

    try {
      const res = await api.updateProfile(form);
      if (res.success) {
        setMessage("Profile updated successfully!");
        setForm(f => ({ ...f, password: "" })); // Clear password
        if (onUpdate) onUpdate(res.user);
      }
    } catch (err) {
      setError(err.message || "Failed to update profile");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card extra={"w-full h-full p-3"}>
      {/* Header */}
      <div className="mt-2 mb-8 w-full flex flex-col md:flex-row md:items-center md:justify-between px-2">
        <div>
          <h4 className="text-xl font-bold text-navy-700 dark:text-white">
            General Information
          </h4>
          <p className="mt-2 text-base text-gray-600">
            Update your personal details, email address, and security settings.
          </p>
        </div>
        
        <div className="mt-4 md:mt-0 flex items-center gap-4">
          {message && <span className="text-sm font-bold text-brand-500">{message}</span>}
          {error && <span className="text-sm font-bold text-red-500">{error}</span>}
          <button
            onClick={handleSubmit}
            disabled={saving}
            className="linear rounded-[20px] bg-brand-500 px-6 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 disabled:opacity-70 shadow-lg shadow-brand-500/30"
          >
            {saving ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>

      {/* Cards - Replaced with Inputs */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-2">
        <div className="flex flex-col items-start justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          <p className="text-sm text-gray-600 mb-1">Full Name</p>
          <input
            type="text"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            placeholder="John Doe"
            className="w-full text-base font-medium text-navy-700 bg-transparent outline-none dark:text-white placeholder:text-gray-400"
          />
        </div>

        <div className="flex flex-col items-start justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          <p className="text-sm text-gray-600 mb-1">Email Address</p>
          <input
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="admin@moviesys.com"
            className="w-full text-base font-medium text-navy-700 bg-transparent outline-none dark:text-white placeholder:text-gray-400"
          />
        </div>

        <div className="flex flex-col items-start justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          <p className="text-sm text-gray-600 mb-1">New Password</p>
          <input
            type="password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            placeholder="Leave blank to keep current"
            className="w-full text-base font-medium text-navy-700 bg-transparent outline-none dark:text-white placeholder:text-gray-400"
          />
        </div>

        <div className="flex flex-col items-start justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          <p className="text-sm text-gray-600 mb-1">Account Role</p>
          <p className="w-full text-base font-medium text-navy-700 dark:text-white">
            {session?.role || "Administrator"} (Read Only)
          </p>
        </div>
      </div>
    </Card>
  );
};

export default EditProfile;
